import PropTypes from 'prop-types'
import { NewTabLink } from '../link'

const Copyright = ({ startYear }) => {
  const current = new Date().getFullYear()
  const dates =
    startYear && startYear < current ? `${startYear}-${current} ` : current
  return (
    <span className='copyright'>{`© ${dates} College of Medicine Research Information Technology & The Ohio State University Clinical and Translational Science Institute (CTSI)`}</span>
  )
}

Copyright.propTypes = {
  startYear: PropTypes.number
}

const Link = ({ url, children }) => (
  <a href={url} className='btn-link' target='_blank' rel='noopener noreferrer'>
    {children}
  </a>
)

Link.propTypes = {
  url: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
}

/** the footer for the site */
const Footer = () => (
  <footer>
    <p>
      Built through a collaborative investment in Translational Infrastructure
      by The Ohio State University{' '}
      <NewTabLink url='https://ctsi.osu.edu/'>
        Clinical and Translational Science Institute (CTSI)
      </NewTabLink>{' '}
      at{' '}
      <NewTabLink url='https://www.osu.edu/'>
        The Ohio State University
      </NewTabLink>{' '}
      (National Center for Advancing Translational Sciences, Grant UM1TR004548)
      and{' '}
      <NewTabLink url='https://medicine.osu.edu/research/information-technology'>
        The Research Information Technology ({'{rit}'})
      </NewTabLink>{' '}
      department within the{' '}
      <NewTabLink url='https://medicine.osu.edu/'>
        College of Medicine
      </NewTabLink>{' '}
      to provide world-class infrastructure to advance biomedical research in
      health sciences colleges.
    </p>
    <section aria-labelledby='accessibility-request'>
      <h2 id='accessibility-request' className='h5 font-weight-bold'>
        Accessibility Requests
      </h2>
      <p>
        If you need an accessibility accommodation to use this site, please
        contact RIT Service Management at&nbsp;
        <a href='mailto:rsm@osumc.atlassian.net?subject=Accessibility%20Request'>
          rsm@osumc.atlassian.net
        </a>
        .
      </p>
    </section>
    <p>
      <Copyright startYear={2020} />
      {' • '}
      <NewTabLink url='https://it.osu.edu/privacy'>Privacy Policy</NewTabLink>
    </p>
  </footer>
)

export { Footer }
